import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

export const Nav = styled.nav`
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  margin: var(--header-height) 0 0;
  z-index: 1;

  ${mq.large} {
    display: block;
  }

  ul {
    margin: 0;
    padding: var(--container-spacing);
  }
`

export const Li = styled.li<{ isActive?: boolean }>`
  margin: 0 0 0.8em;
  list-style: none;
  font-size: 2rem;
  font-weight: 500;

  button {
    ${styleReset};
    vertical-align: top;
    width: calc((100vw - (11 * var(--grid-size) + 9 * var(--gap-size))) / 2);
    max-width: 15em;

    &:not(:disabled) {
      cursor: pointer;
    }
  }

  &::before {
    content: url("data:image/svg+xml,%3Csvg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 9.49952L15.4401 10.7028C13.2091 11.457 11.458 13.2082 10.7038 15.4391L9.50048 18.999L8.29721 15.4391C7.543 13.2082 5.79183 11.457 3.56088 10.7028L0 9.49952L3.55992 8.29625C5.79087 7.54204 7.54204 5.79087 8.29625 3.55992L9.49952 0L10.7028 3.55992C11.457 5.79087 13.2082 7.54204 15.4391 8.29625L18.999 9.49952H19Z' fill='%23343431'/%3E%3C/svg%3E%0A");
    display: inline-block;
    vertical-align: middle;
    margin: -0.4rem 0.9rem 0 0;
    transition: 0.2s transform;

    ${props =>
      !props.isActive &&
      css`
        transform: scale(0.6);
      `}
  }
`
